module.exports = __webpack_public_path__ + "img/2018-2.344c421a.jpg";